var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 503.379,
    height: 310.297,
    viewBox: "0 0 503.379 310.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(-87.597 561.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M500.461-251.493c-31.283,0-51.225-23.309-80.981-35.192a163.365,163.365,0,0,0-58.629-10.672,179.39,179.39,0,0,0-76,17.089c-26.729,12.013-64.428,22.933-99.566,22.933-42.275,0-80.841-15.815-92.094-64.559-7.7-33.125,3.623-56.335,34.042-68.7,11.645-4.536,23.7-11.372,30.278-23.039,9.076-15.579-1.671-39.148-3.693-55.835-5.493-47.661,21.159-60.261,57.644-60.261,20.467,0,44.029,3.967,66.744,7.932s44.581,7.932,61.663,7.931c7.08,0,13.34-.681,18.495-2.327l-2.745.189c12.62-3.669,19.136-16.268,30.719-21.735a47.336,47.336,0,0,1,18.883-4.156c34.819,0,57.053,43.849,89.074,52.848,16.833,4.456,32.257,1.531,49.275,8.777,20.8,8.859,31.545,32.427,31.255,55.814-1.328,21.593-18.585,35.56-28.391,53.992-11.635,18.559-7.423,26.683-1.557,45.909C555.2-293.475,549.863-260.091,514.5-253a68.372,68.372,0,0,1-14.041,1.5",
    fill: "#ffb81c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M339.439-524.207c-4.729,0-4.729-7.333,0-7.333s4.729,7.333,0,7.333",
    transform: "translate(0 -1)",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M122.19-411.456c-9.458,0-9.458-14.667,0-14.667s9.458,14.667,0,14.667",
    transform: "translate(0 1)",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M563.105-352.974c-9.459,0-9.459-14.667,0-14.667s9.459,14.667,0,14.667",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M314.69-527.873c-9.459,0-9.459-14.667,0-14.667s9.457,14.667,0,14.667",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M577.772-376.256c-12.3,0-12.3-19.067,0-19.067s12.3,19.067,0,19.067",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M97.44-387.256c-12.3,0-12.3-19.067,0-19.067s12.3,19.067,0,19.067",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M504.439-501.84c-12.3,0-12.3-19.067,0-19.067s12.3,19.067,0,19.067",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M335.772-539.789c-14.187,0-14.187-22,0-22s14.188,22,0,22",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M585.656-359.024c-7.093,0-7.093-11,0-11s7.093,11,0,11",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M94.874-417.874c-7.094,0-7.094-11,0-11s7.094,11,0,11",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M527.356-491.207c-7.095,0-7.095-11,0-11s7.093,11,0,11",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M525.523-511.373c-4.729,0-4.729-7.333,0-7.333s4.728,7.333,0,7.333",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M154.09-524.024c-9.457,0-9.457-14.667,0-14.667s9.459,14.667,0,14.667",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M571.356-271.206c-9.459,0-9.459-14.667,0-14.667s9.457,14.667,0,14.667",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M94.69-264.79c-9.458,0-9.458-14.667,0-14.667s9.458,14.667,0,14.667",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M176.09-535.024c-4.729,0-4.729-7.333,0-7.333s4.729,7.333,0,7.333",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M572.272-300.539c-4.729,0-4.729-7.333,0-7.333s4.729,7.333,0,7.333",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M116.69-255.623c-4.729,0-4.729-7.333,0-7.333s4.729,7.333,0,7.333",
    fill: "rgba(255,184,28,0.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M221.375-379.092c-4.94,1.744-8.2,2.079-10.733-2.919-1.948-3.847-3.248-7.82-5.7-11.421-5.317-7.805-10.468-8.329-18.981-7.217-8.451,1.1-19.979-1.055-21.261-10.827-.915-6.965-.968-13.369-4.017-19.885-1.5-3.211-6.243-.416-4.748,2.776,3.383,7.229,1.9,15.1,4.379,22.465,2.512,7.472,10.877,9.881,17.908,10.72,5.313.633,9.965-.648,15.175-.641,5.595.007,9.413,9.6,11.188,13.816,3.695,8.783,8.932,11.729,18.255,8.436,3.321-1.172,1.891-6.487-1.461-5.3",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M163.252-438.784a16.43,16.43,0,0,1-6.056,4.711c-2.533,1.276-.305,5.072,2.221,3.8a21.135,21.135,0,0,0,7.635-6.288,2.2,2.2,0,0,0-.789-3.011,2.254,2.254,0,0,0-3.011.789",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M155.374-444.64c.012,4.652.691,9.28.733,13.933.025,2.836,4.425,2.839,4.4,0-.041-4.653-.72-9.281-.732-13.933-.008-2.837-4.408-2.837-4.4,0",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M147.952-440.151c2.944,3.68,5.935,7.351,9.977,9.876,2.415,1.508,4.621-2.3,2.221-3.8-3.692-2.305-6.4-5.833-9.088-9.188-1.772-2.216-4.864.919-3.111,3.111",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "M144.285-433.552a14.308,14.308,0,0,0,14.607,3.5c2.705-.827,1.552-5.075-1.169-4.244a9.847,9.847,0,0,1-10.327-2.367c-2.059-1.948-5.176,1.159-3.111,3.111",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M446.323-365.442c.2-7.187,2.6-9.585,9.539-10.151,4.508-.368,9.081-.305,13.54-1.136,6.8-1.267,6.679-10.653,9.311-15.5,4.021-7.4,14.824-6.612,21.8-8.8,7.681-2.407,10.629-8.909,11.081-16.483.213-3.545-5.288-3.524-5.5,0-.673,11.267-8.937,11.659-18.012,13.525-8,1.647-13.419,6.031-16.2,13.74-.871,2.413-1.081,7.444-3.939,8.211-4.651,1.247-10,.677-14.789,1.2-8.992.973-12.091,6.86-12.327,15.393-.1,3.549,5.4,3.54,5.5,0",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M498.651-424.256a17.392,17.392,0,0,0,9.6,9.6,2.2,2.2,0,0,0,2.707-1.537,2.256,2.256,0,0,0-1.537-2.707,12.415,12.415,0,0,1-6.531-6.529,2.255,2.255,0,0,0-2.705-1.537,2.2,2.2,0,0,0-1.537,2.707",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "M505.172-429.974v11c0,2.837,4.4,2.837,4.4,0v-11c0-2.837-4.4-2.837-4.4,0",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "M512.584-429.092a20.308,20.308,0,0,1-6.768,9.3c-2.2,1.795.933,4.888,3.112,3.111a24.411,24.411,0,0,0,7.9-11.237c.932-2.688-3.319-3.832-4.243-1.169",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M517.94-424.484a16.894,16.894,0,0,1-8.219,6.323c-2.588,1.061-1.457,5.32,1.169,4.244,4.384-1.8,8.275-4.264,10.849-8.345,1.517-2.407-2.291-4.613-3.8-2.221",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "M472.543-285.753c0,3.847-28.805,4.964-31.919,4.964H225.055c-3.109,0-31.919-1.117-31.919-4.964l26.285-39.4c0-3.848,2.524-6.967,5.633-6.967H440.624c3.113,0,5.633,3.119,5.633,6.967l26.285,39.4",
    fill: "#a8aaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M288.509-294.53h-55.4L242.8-318H292.91l-4.4,23.467",
    fill: "#2f3031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M377.171-294.53h55.4L422.876-318H372.77l4.4,23.467",
    fill: "#2f3031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M438.731-294.53H458.24L442.276-318H427.559l11.172,23.467",
    fill: "#2f3031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "M226.951-294.53H207.441L223.406-318h14.715L226.951-294.53",
    fill: "#2f3031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "M372.3-294.53H293.381l4.4-23.467H367.9l4.4,23.467",
    fill: "#2f3031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M453.426-310.122H212.255v-3.592h241.17v3.592",
    fill: "#a8aaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "M456.04-301.322h-246.4v-3.593h246.4v3.593",
    fill: "#a8aaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "M474.019-276.627c0,3.111-.645,5.632-3.753,5.632H195.416c-3.113,0-3.755-2.521-3.755-5.632v-4.829c0-3.111.641-5.631,3.755-5.631h274.85c3.108,0,3.753,2.52,3.753,5.631v4.829",
    fill: "#2f3031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M384.356-278.907a2.935,2.935,0,0,1-2.933,2.935H284.257a2.935,2.935,0,0,1-2.933-2.935,2.933,2.933,0,0,1,2.933-2.933h97.166a2.933,2.933,0,0,1,2.933,2.933",
    fill: "#5f6365"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "M449.074-330.474a5.633,5.633,0,0,1-5.635,5.633h-221.2a5.634,5.634,0,0,1-5.635-5.633v-144.31a5.635,5.635,0,0,1,5.635-5.635h221.2a5.635,5.635,0,0,1,5.635,5.635v144.31",
    fill: "#2f3031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M332.841-472.582c3.027,0,3.027-4.695,0-4.695s-3.028,4.695,0,4.695",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "M432.8-339.546a4.845,4.845,0,0,1-4.843,4.845H237.723a4.847,4.847,0,0,1-4.847-4.845v-124.1a4.847,4.847,0,0,1,4.847-4.845H427.959a4.845,4.845,0,0,1,4.843,4.845v124.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M302.182-419.747l-16.595,16.592a2.2,2.2,0,0,0,0,3.112,2.2,2.2,0,0,0,3.111,0l16.595-16.592a2.2,2.2,0,0,0,0-3.112,2.2,2.2,0,0,0-3.112,0",
    fill: "#335574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "M305.293-403.151,288.7-419.746a2.2,2.2,0,0,0-3.111,0,2.2,2.2,0,0,0,0,3.112l16.593,16.593a2.2,2.2,0,0,0,3.111,0,2.2,2.2,0,0,0,0-3.111",
    fill: "#335574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "M376.982-419.747l-16.6,16.592a2.2,2.2,0,0,0,0,3.112,2.2,2.2,0,0,0,3.112,0l16.595-16.592a2.2,2.2,0,0,0,0-3.112,2.2,2.2,0,0,0-3.111,0",
    fill: "#335574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "M380.092-403.151,363.5-419.746a2.2,2.2,0,0,0-3.112,0,2.2,2.2,0,0,0,0,3.112l16.593,16.593a2.2,2.2,0,0,0,3.111,0,2.2,2.2,0,0,0,0-3.111",
    fill: "#335574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M371.088-381.574V-365.2a5.866,5.866,0,0,1-5.867,5.867h-3.164a5.866,5.866,0,0,1-5.867-5.867v-16.377",
    fill: "#f57eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "M366.212-380.719l-2.573,19.067-2.572-19.067Z",
    fill: "#f363a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M283.115-379.759h99.449a1.833,1.833,0,0,0,1.833-1.833,1.834,1.834,0,0,0-1.833-1.833H283.115a1.834,1.834,0,0,0-1.833,1.833,1.833,1.833,0,0,0,1.833,1.833",
    fill: "#335574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "M266.841-384.018c9.459,0,9.459-14.667,0-14.667s-9.459,14.667,0,14.667",
    fill: "#f8adca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "M398.84-384.018c9.459,0,9.459-14.667,0-14.667s-9.459,14.667,0,14.667",
    fill: "#f8adca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "M411.306-499.64v48.4c0,4.729,7.333,4.729,7.333,0v-48.4c0-4.729-7.333-4.729-7.333,0",
    fill: "#f48617"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M414.972-432.54c7.095,0,7.095-11,0-11s-7.093,11,0,11",
    fill: "#f48617"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.93facdc62935876591c0f0c3816b08a0.svg";
export { ForwardRef as ReactComponent };